import {
  DefaultGlobalNotFound,
  Outlet,
  createRootRoute,
} from "@tanstack/react-router"
import faviconUrl from "@motleyhand/design/favicon.svg?no-inline"
import { meta } from "@/content"
import { withProfiler } from "@/monitoring"
import { Root } from "@/base"
import appCss from "@/index.css?url"

export const Route = createRootRoute({
  head: ({ matches }) => {
    const canonicalUrl = `https://promptjuggler.com${matches[matches.length - 1]?.pathname ?? "/"}`

    return {
      meta: [
        { charSet: "utf-8" },
        { name: "viewport", content: "initial-scale=1, width=device-width" },
        { name: "theme-color", content: "#ff5500" },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonicalUrl },
        { property: "og:site_name", content: "PromptJuggler" },
        {
          property: "og:image",
          content: "https://promptjuggler.com/promptjuggler_og.png",
        },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:site", content: "@MotleyHand" },
        {
          name: "twitter:image",
          content: "https://promptjuggler.com/promptjuggler_og.png",
        },
        ...meta({
          title: "PromptJuggler – AI Prompt, Workflow & Agent Platform",
          description:
            "Tame the AI circus. Author prompts, build workflows and agents, test and scale – one platform, no framework, free to start.",
          socialTitle: "PromptJuggler – Tame the AI Circus",
          socialDescription:
            "Author prompts, build agents, test at scale. Complex underneath, simple on the outside – for people who care about their craft.",
        }),
      ],
      links: [
        { rel: "stylesheet", href: appCss },
        { rel: "icon", href: faviconUrl, type: "image/svg+xml" },
        { rel: "apple-touch-icon", href: "/apple-touch-icon.png" },
        { rel: "canonical", href: canonicalUrl },
      ],
      scripts: [
        { src: "/env.js" },
        {
          // Load Huginn (Umami) and route every event through maskTenant, which
          // strips the /t/<tenantSlug> segment from url + referrer to /t/[id]
          // before send so tenant slugs never reach analytics
          children:
            '(function(){window.maskTenant=function(t,p){if(p){var r=new RegExp("/t/[^/?#]+","g");if(p.url)p.url=p.url.replace(r,"/t/[id]");if(p.referrer)p.referrer=p.referrer.replace(r,"/t/[id]")}return p};var e=window.env;if(e&&e.HUGINN_ID){var s=document.createElement("script");s.defer=true;s.src="https://huginn.motley.dev/huginn.js";s.dataset.websiteId=e.HUGINN_ID;s.dataset.beforeSend="maskTenant";document.head.appendChild(s)}})()',
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            name: "PromptJuggler",
            description:
              "AI prompt, workflow and agent platform. Author prompts, build workflows, evaluate quality, run at scale.",
            url: "https://promptjuggler.com",
            applicationCategory: "DeveloperApplication",
            operatingSystem: "Web",
            browserRequirements: "Requires a modern web browser",
            author: {
              "@type": "Organization",
              name: "Motley Hand",
              url: "https://motleyhand.com",
            },
            offers: {
              "@type": "AggregateOffer",
              priceCurrency: "USD",
              lowPrice: "0",
              highPrice: "995",
              offerCount: "4",
            },
          }),
        },
      ],
    }
  },
  component: withProfiler(() => (
    <Root>
      <Outlet />
    </Root>
  )),
  notFoundComponent: DefaultGlobalNotFound,
})
